import React from 'react';
import Navbarh from './navbar/Navbar';
import { Row, } from 'reactstrap';
import Menu from './navbar/Menu';


function Home() {
    return (
        <>
            <Navbarh />
            <div className='home '>
                <Row className="mt-4">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <Menu />
                    </div>
                </Row>
            </div>
        </>
    )
}

export default Home
